import {IProfileItemModel, ProfileItemModel} from './profile-item.model';

export interface ISchulung extends IProfileItemModel {
  uuid?: string;
  beginn?: Date | string;
  schulungsanbieter?: string;
  lehrgang?: string;
  forExport?: boolean;
  uploadId?: string;
}

export class Schulung extends ProfileItemModel implements ISchulung {
  constructor(
    public uuid?: string,
    public beginn?: Date,
    public schulungsanbieter?: string,
    public lehrgang?: string,
    public forExport?: boolean,
    public uploadId?: string
  ) {
    super();
    this.beginn = beginn ? beginn : new Date(Date.now());
    this.schulungsanbieter = schulungsanbieter ? schulungsanbieter : undefined;
    this.lehrgang = lehrgang ? lehrgang : undefined;
    this.forExport = forExport ? forExport : true;
    this.uploadId = uploadId ? uploadId : undefined;
  }

  static emptyObject(): Schulung {
    const s = new Schulung();
    s.beginn = new Date();
    s.schulungsanbieter = '';
    s.lehrgang = '';
    s.uploadId = '';
    s.forExport = true;
    return s;
  }

  static fromJson(json: ISchulung) {
    const schulung = new Schulung();
    schulung.uuid = json.uuid;
    schulung.schulungsanbieter = json.schulungsanbieter;
    schulung.lehrgang = json.lehrgang;
    schulung.beginn = this.anyToDate(json.beginn);
    schulung.forExport = json.forExport;
    schulung.uploadId = json.uploadId;
    return schulung;
  }

  newInstance<T extends ProfileItemModel>(): T {
    return new Schulung() as T;
  }
}
